import React from 'react';
import { Upload, X } from 'lucide-react';
import { Button } from '../../../components/ui/button';

export default function AttachmentsStep({ files, onFileUpload, onFileDelete }) {
  return (
    <div data-testid="attachments-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Attachments (Optional)
      </h2>
      <p className="text-[#475569] mb-6">
        Upload any relevant documents (PDF, Word, Excel, CSV, images). Up to 10 files, 25MB each.
      </p>

      <div className="mb-6">
        <label
          htmlFor="file-upload"
          className="flex items-center justify-center w-full p-8 border-2 border-dashed border-[#e2e8f0] rounded-lg hover:bg-[#f8fafc] cursor-pointer transition-colors"
          data-testid="file-upload-area"
        >
          <div className="text-center">
            <Upload className="w-12 h-12 text-[#5b93d6] mx-auto mb-2" />
            <p className="text-sm font-medium text-[#0f172a]">Click to upload</p>
            <p className="text-xs text-[#475569] mt-1">PDF, DOC, XLS, CSV, JPG, PNG (max 25MB)</p>
          </div>
          <input
            id="file-upload"
            type="file"
            className="hidden"
            onChange={onFileUpload}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.gif"
          />
        </label>
      </div>

      {files.length > 0 && (
        <div className="space-y-2">
          <h3 className="text-sm font-medium text-[#0f172a] mb-2">Uploaded Files ({files.length}/10)</h3>
          {files.map((file) => (
            <div
              key={file.id}
              className="flex items-center justify-between p-3 bg-[#f8fafc] rounded-md border border-[#e2e8f0]"
            >
              <span className="text-sm text-[#0f172a]">{file.filename}</span>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => onFileDelete(file.id)}
                data-testid={`delete-file-${file.id}`}
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
